<template>
  <v-container fluid class="crm-conversation">
    <v-row class="mb-4" v-if="$store.state.users.loadingClient">
      <v-col cols="12">
				<div class="d-flex flex-column justify-center align-center">
					<v-progress-circular
						:size="50"
						:width="5"
						color="rgba(0,0,0,0.2)"
						class="mb-3"
						indeterminate
					></v-progress-circular>
					Cargando Información
				</div>
      </v-col>
    </v-row>
		<div v-else-if="client">
			<v-row>
				<v-col cols="12" v-show="!hideFirstCol" style="overflow-y:scroll;" :style="'height:'+$store.getters['general/availableHeight']+'px'">
					<v-card class="mb-4">
						<v-card-text class="py-2">
							<div class="d-flex align-center justify-space-between">
								<div class="d-flex align-center">
									<p class="font-weight-bold body-2 mb-0 mr-2">Datos Cliente</p>
								</div>
							</div>
							<v-divider class="my-1"></v-divider>
							<div class="pa-2" v-if="client">
								<div v-if="editUser">
									<div class="d-flex justify-space-between align-center mb-1">
										<span class="mr-5">Nombre: </span>
										<v-text-field
											v-model="userData.name"
											outlined
											required
											dense
											hide-details
											style="max-width: 75%"
										></v-text-field>
									</div>
									<div class="d-flex justify-space-between align-center mb-1">
										<span class="mr-5">Email: </span>
										<v-text-field
											v-model="userData.email"
											outlined
											required
											dense
											hide-details
											style="max-width: 75%"
										></v-text-field>
									</div>
									<div class="d-flex justify-space-between align-center mb-1">
										<span class="mr-5">Teléfono: </span>
										<v-text-field
											v-model="userData.phone"
											outlined
											required
											dense
											style="max-width: 75%"
											:rules="phoneRule"
											maxlength="11"
											@keypress="isNumberKey"
										></v-text-field>
									</div>
									<v-btn
										depressed
										color="#524D4D"
										dark
										block
										small
										class="mt-3"
										:loading="loadingEditUser"
										@click="editUserData()"
									>
										<v-icon small>mdi-account-edit</v-icon>
										<p class="mb-0 ml-2 caption">Confirmar Cambios</p>
									</v-btn>
								</div>
								<div v-else>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.profile.name}} {{client.profile.lastname}} {{client.profile.second_lastname}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.email}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.profile?.rut | formatRut}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.profile?.phone}}</b></div>
								</div>
							</div>
							<div class="pa-2" v-else>
								No se logró obtener datos de usuario
							</div>
						</v-card-text>
					</v-card>
					<v-tabs v-model="tab" class="custom-color-tabs" show-arrows grow @change="onChangeTabFromClick">
						<v-tab>CRM / VT</v-tab>
						<v-tab>Antecedentes</v-tab>
						<v-tab>Informes</v-tab>
						<v-tab>Presupuestos</v-tab>
						<v-tab>Contratos Y Costos</v-tab>
						<v-tab>Proyectos</v-tab>
						<v-tab>Supervisión de Obra /<br/> Construcción</v-tab>
						<v-tab>Solicitudes</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab" class="tab-item-custom" style="width: 100%; flex-grow: 1;">
						<v-tab-item>
							<div>
								<CrmList :clientId="clientId" :openCrmDetail="handleOpenCrmDetail" :openReportDetail="handleOpenReportDetail"/>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div>
								<PreProjectList :clientId="clientId" :openPreProjectDetail="handleOpenPreProjectDetail" :openReportDetail="handleOpenReportDetail"/>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
								<ReportList :clientId="clientId" :openReportDetail="handleOpenReportDetail"/>
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
								<BudgetList :clientId="clientId" :openBudgetDetail="handleOpenBudgetDetail" />
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
								<ContractList :clientId="clientId" :openContractDetail="handleOpenContractDetail" />
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
							</div>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
								<RequestList :clientId="clientId" :openRequestDetail="handleOpenRequestDetail" :openCrmDetail="handleOpenCrmDetail"/>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-col>
			</v-row>
		</div>
  </v-container>
</template>

<script>
import {getReportById} from '@/helpers/api/reports'

import CrmList from '@/components/Views/Clients/Parts/CRM/IndexClient'
import PreProjectList from '@/components/Views/Clients/Parts/PreProjects/IndexClient'
import ContractList from '@/components/Views/Clients/Parts/Contracts/IndexClient'
import BudgetList from '@/components/Views/Clients/Parts/Budgets/IndexClient'
import ReportList from '@/components/Views/Clients/Parts/Reports/IndexClient'
import RequestList from '@/components/Views/Clients/Parts/Requests/IndexClient'

export default {
	name: 'MyClientDetail',
  components: { CrmList, PreProjectList, ContractList, BudgetList, ReportList, RequestList},
  data() {
    return {
			hideFirstCol: false,
			clientId: null,
			selectedCrmId: null,
			selectedPreProjectId: null,
			selectedContractId: null,
			selectedBudgetId: null,
			selectedReportId: null,
			mapZoom: 7,
      zoomInterval: null,
      isZooming: false,
			itemsAddress: [],
			loadingAddress: false,
			search: '',
			autocompleteService: null,
			tab: null,
			items: ['Información', 'Conversación', 'Correos Enviados', 'Informes'],
			reportTemplate: null,
			loading: false,
			editValue: false,
			editProjectDetail: false,
			editScheduleTitle: false,
			editUser: false,
			editAddress: false,
			newValueCrm: null,
			newScheduleTitle: null,
			newProjectDetail: null,
			loadingEditUser: false,
			reportEditor: '',
			menuTemplates: false,
			cc_report: null,
			scheduledUserId: null,
			changingScheduleUser: false,
			subject: 'Informe Visita Técnica',
			report_title: 'Informe Visita Técnica Revisión Normativa',
			activePanel: null,
			activePanelB: null,
			templateName: null,
			userData: {
				name: null,
				email: null,
				phone: null
			},
			cachingItems: false,
			newAddress: {address: null, coordinates: null},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			phoneRule: [
				v => !!v || 'Campo requerido',
				v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
			],
    };
  },
  computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		editPermission(){
			return true
		},
		client(){
			return this.$store.state.users.client
		},
		queryRoute(){
			return this.$route.query
		}
  },
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.clientId = parseInt(this.$store.state.user.userInfo.id)
				try {
					this.$store.dispatch('users/getCompanyClient', this.clientId)
				} catch (error) {
					console.log('Error: ', error)
				}
			}
		},
		queryRoute(){
			const preproject_id = this.$route.query.p
			const crm_id = this.$route.query.crm
			const contract_id = this.$route.query.ct
			const budget_id = this.$route.query.b
			const budget_report_id = this.$route.query.br
			const report_id = this.$route.query.r
			const request_id = this.$route.query.ur
			const project_additional_request_id = this.$route.query.par
			if(preproject_id){
				this.tab = 1
				this.handleOpenPreProjectDetail(preproject_id)
			}
			else if(crm_id){
				this.tab = 0
				this.handleOpenCrmDetail(crm_id)
			}
			else if(report_id){
				this.tab = 2
				this.handleOpenReportDetail(report_id)
			}
			else if(budget_id){
				this.tab = 3
				this.handleOpenBudgetDetail(budget_id)
			}
			else if(contract_id){
				this.tab = 4
				this.handleOpenContractDetail(contract_id)
			}
			else if(request_id){
				this.tab = 7
				this.handleOpenRequestDetail(request_id)
			}
			else if(budget_report_id){
				this.tab = 0
				this.handleOpenReportDetail(budget_report_id)
			}
			else if(project_additional_request_id){
				this.tab = 4
				this.handleOpenProjectAdditionalRequestDetail(project_additional_request_id)
			}
			else {
				this.hideFirstCol = false
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.clientId = parseInt(this.$store.state.user.userInfo.id)
			try {
				this.$store.dispatch('users/getCompanyClient', this.clientId)
			} catch (error) {
				console.log('Error: ', error)
			}
		}
		const preproject_id = this.$route.query.p
		const crm_id = this.$route.query.crm
		const contract_id = this.$route.query.ct
		const budget_id = this.$route.query.b
		const budget_report_id = this.$route.query.br
		const report_id = this.$route.query.r
		const request_id = this.$route.query.ur
		const project_additional_request_id = this.$route.query.par
		if(preproject_id){
			this.tab = 1
			this.handleOpenPreProjectDetail(preproject_id)
		}
		else if(crm_id){
			this.tab = 0
			this.handleOpenCrmDetail(crm_id)
		}
		else if(report_id){
			this.tab = 2
			this.handleOpenReportDetail(report_id)
		}
		else if(budget_id){
			this.tab = 3
			this.handleOpenBudgetDetail(budget_id)
		}
		else if(contract_id){
			this.tab = 4
			this.handleOpenContractDetail(contract_id)
		}
		else if(request_id){
			this.tab = 7
			this.handleOpenRequestDetail(request_id)
		}
		else if(budget_report_id){
			this.tab = 0
			this.handleOpenReportDetail(budget_report_id)
		}
		else if(project_additional_request_id){
			this.tab = 4
			this.handleOpenProjectAdditionalRequestDetail(project_additional_request_id)
		}
		else {
			this.hideFirstCol = false
		}
	},
	beforeDestroy(){
		this.$store.commit('users/setClient', null)
	},
  methods: {
		onChangeTabFromClick(){
			this.setAllSelectedToValue()
			this.$router.replace({ query: {} })
		},
		changeColSize(){
			this.hideFirstCol = !this.hideFirstCol
		},
		handleOpenCrmDetail(crm_id){
			this.setAllSelectedToValue()
			this.selectedCrmId = crm_id
			this.$store.commit('crm/setCrmModalId', crm_id)
			// this.$router.replace({  query: {crm: crm_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenPreProjectDetail(preproject_id){
			this.setAllSelectedToValue()
			this.selectedPreProjectId = preproject_id
			this.$store.commit('preprojects/setPreProjectModalId', preproject_id)
			// this.$router.replace({  query: {p: preproject_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenContractDetail(contract_id){
			this.setAllSelectedToValue()
			this.selectedContractId = contract_id
			this.$router.replace({ 
				query: { ct: contract_id }, 
				hash: this.$route.hash 
			}).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
			this.$store.commit('contracts/setContractModalId', contract_id)
		},
		handleOpenBudgetDetail(budget_id){
			this.setAllSelectedToValue()
			this.selectedBudgetId = budget_id
			this.$store.commit('budget/setBudgetModalId', budget_id)
			// this.$router.replace({  query: {b: budget_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenReportDetail(report_id){
			this.setAllSelectedToValue()
			this.selectedReportId = report_id
			this.getReport()
			// this.$router.replace({  query: {r: report_id} }).catch(err => {if (err.name !== 'NavigationDuplicated') throw err;})
		},
		handleOpenRequestDetail(request_id){
			this.$store.commit('userrequests/setUserRequestModalId', request_id)
		},
		handleOpenProjectAdditionalRequestDetail(additional_request_id){
			this.$store.commit('projects/setAdditionalRequirementDetailModal', {
				additional_request_id
			})
		},
		async getReport(){
			const report = await getReportById({report_id: this.selectedReportId})
			if(report.code == 200){
				if(report.report?.budget){
					this.$store.commit('reports/setReportModalId', report.report.id)
				}
				else{
					this.$store.commit('reports/setReportPdfModal', {...report.report, ...{viewer_only: true, is_client: true}})
				}
			}
		},
		setAllSelectedToValue(value = null){
			this.selectedCrmId = value
			this.selectedPreProjectId = value
			this.selectedContractId = value
			this.selectedBudgetId = value
			this.selectedReportId = value
		},
		toConversationDetail(crm) {
			// this.$router.push({ name: 'Conversation', params: { id: crm.id } })
			this.$store.commit('crm/setCrmModalId', crm.id)
		},
		toPreProjectDetail(preproject) {
			// this.$router.push({ name: 'PreProject', params: { id: preproject.id } })
			this.$store.commit('preprojects/setPreProjectModalId', preproject.id)
		},
  },
};
</script>

<style scoped>
	.client-items-container{
		border: 1px solid rgb(213, 211, 211);
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.vertical-tabs .rotated-tab {
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		text-align: center;
		height: 150px;
		line-height: 1;
	}

	.vertical-tabs .v-tab {
		justify-content: center;
		align-items: center;
		min-height: 100px;
		padding: 0px;
		min-width: 40px;
		width: 40px;
		font-size: 12px;
	}
	.vertical-tabs {
		align-items: flex-start;
		height: 100%;
	}
	.vertical-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		border: 2px solid #959595;
		color: #FFFFFF;
	}
	.vertical-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	.tab-item-custom .v-window__container{height: auto;}
	.change-col-size{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
	.tab-item-custom .v-window__container{height: auto;}
</style>